import CheckIcon from '@common/assets/icons/check.svg?react';
import { Cell, type CellProps } from '@common/ui/Cell';
import { Separator } from '@common/ui/Separator';

interface Item {
  value: string;
  label: string;
}

interface Props
  extends Omit<
    CellProps,
    'suffixIcon' | 'onChange' | 'subtitle' | 'title' | 'testId'
  > {
  items: Item[];
  value?: string;
  onChange?: (value: string) => void;
}

export const CellSelect = ({ items, value, onChange }: Props) => {
  const onChangeHandler = (value: string) => {
    onChange?.(value);
  };

  return (
    <>
      {items.map((item, index) => (
        <Cell
          key={item.value}
          testId={`cell-select-option-${item.value}`}
          title={item.label}
          data-selected={item.value === value}
          separator={index < items.length - 1 ? <Separator /> : undefined}
          onClick={() => onChangeHandler(item.value)}
          suffixIcon={
            item.value === value ? (
              <CheckIcon color="var(--graphic-action-primary)" />
            ) : undefined
          }
        />
      ))}
    </>
  );
};
